import { useApi } from "../../../hooks/useApi";
import { useCallback } from "react";
import { urlReplacer } from "../../../utils";
import { objectToFormData } from "../../../utils/objectToFormData";
import { ApiRoutes } from "../../../constants/apiRoutes";

export default function () {
  const { request } = useApi();
  return {
    fetchAll: useCallback(async () => {
      return request({
        method: "GET",
        url: `${ApiRoutes.SCHOOLS}`,
      });
    }, [request]),

    fetchSchoolBranches: useCallback(
      async (id) => {
        return request({
          method: "GET",
          url: `${urlReplacer(ApiRoutes.SCHOOL_BRANCHES, {
            id,
          })}`,
        });
      },
      [request],
    ),

    fetchOne: useCallback(
      async (id) => {
        return request({
          method: "GET",
          url: `${urlReplacer(ApiRoutes.GET_SCHOOL, {
            id,
          })}`,
        });
      },
      [request],
    ),

    fetchCreate: useCallback(
      async (data) => {
        return request({
          data: objectToFormData({
            image: data.image,
            country: data.countryObj.code,
            website: data.website,
            name: data.name,
            typeId: data.type && data.type.id,
          }),
          method: "POST",
          url: ApiRoutes.CREATE_SCHOOL,
        });
      },
      [request],
    ),

    fetchUpdate: useCallback(
      async ({ id, ...data }) => {
        return request({
          data: objectToFormData({
            image: data.image,
            country: data.countryObj.code,
            website: data.website,
            name: data.name,
            typeId: data.type && data.type.id,
          }),
          method: "PUT",
          url: urlReplacer(ApiRoutes.UPDATE_SCHOOL, {
            id,
          }),
        });
      },
      [request],
    ),

    fetchDelete: useCallback(
      async (id) => {
        return request({
          method: "DELETE",
          url: `${urlReplacer(ApiRoutes.DELETE_SCHOOL, { id })}`,
        });
      },
      [request],
    ),

    fetchMyFavorites: useCallback(async () => {
      return request({
        method: "GET",
        url: ApiRoutes.MY_FAVORITE_SCHOOLS,
      });
    }, [request]),

    fetchMakeSchoolFavorite: useCallback(
      async (id) => {
        return request({
          method: "POST",
          url: ApiRoutes.MY_FAVORITE_SCHOOLS,
          data: { id },
        });
      },
      [request],
    ),

    fetchRemoveSchoolFavorite: useCallback(
      async (id) => {
        return request({
          method: "DELETE",
          url: `${ApiRoutes.MY_FAVORITE_SCHOOLS}?id=${id}`,
        });
      },
      [request],
    ),
  };
}
